import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import ProductFeature from '../../components/product-detail/product-feature/ProductFeature';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
export const MIN_FEATURES = 2;
const PRODUCT_FEATURES_ID = 'product-features';
const ProductFeaturesContainer = ({ technicalFeatures }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(Stack, { direction: "col", gap: { base: '4', lg: '6' }, id: PRODUCT_FEATURES_ID, children: [_jsx(TextAlpha, { as: "h2", variant: "subheadingXL", children: t('product.features.title') }), _jsx(Stack, { direction: "col", gap: "3", children: technicalFeatures.map(feature => (_jsx(ProductFeature, { feature: feature }, feature.featureId))) })] }));
};
export default ProductFeaturesContainer;
